// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Util$SmartcutsMacros = require("../../bs-utils/src/Util.bs.js");
var Browser__Identity$SmartcutsMacros = require("./browser/Browser__Identity.bs.js");
var JsPromiseErrorUtils$SmartcutsMacros = require("../../bs-utils/src/JsPromiseErrorUtils.bs.js");

function removeCachedAuthTokenAndGetNewAuthTokenAndRetryApiCall(invalidAccessToken, client, fn) {
  return Browser__Identity$SmartcutsMacros.removeCachedAuthToken(invalidAccessToken).then(function (result) {
              if (result.TAG === /* Ok */0) {
                return Browser__Identity$SmartcutsMacros.getAuthToken(false, true, undefined, undefined, undefined).then(function (maybeNewToken) {
                              if (maybeNewToken !== undefined) {
                                return Curry._2(fn, maybeNewToken, client).then(function (return_) {
                                              return Promise.resolve({
                                                          TAG: /* Ok */0,
                                                          _0: {
                                                            TAG: /* MethodDidReturnWithNewToken */1,
                                                            return_: return_,
                                                            newToken: maybeNewToken,
                                                            oldToken: invalidAccessToken
                                                          }
                                                        });
                                            }).catch(function (jsPromiseError) {
                                            return Promise.resolve({
                                                        TAG: /* Error */1,
                                                        _0: {
                                                          TAG: /* MethodDidThrowPromiseError */0,
                                                          errorType: Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.getErrorType, jsPromiseError),
                                                          maybeNewToken: maybeNewToken,
                                                          originalToken: invalidAccessToken
                                                        }
                                                      });
                                          });
                              } else {
                                return Promise.resolve({
                                            TAG: /* Ok */0,
                                            _0: /* OAuthNotGrantedWhenTryingToGetNewToken */0
                                          });
                              }
                            }).catch(function (jsPromiseError) {
                            return Promise.resolve({
                                        TAG: /* Error */1,
                                        _0: {
                                          TAG: /* PromiseErrorWhileGetNewOAuthToken */2,
                                          promiseErrorType: Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.getErrorType, jsPromiseError),
                                          removedToken: invalidAccessToken
                                        }
                                      });
                          });
              }
              var jsExn = result._0;
              console.error(jsExn);
              return Promise.resolve({
                          TAG: /* Error */1,
                          _0: {
                            TAG: /* JsExnWhileRemoveCachedOAuthToken */1,
                            jsExn: jsExn,
                            cachedToken: invalidAccessToken
                          }
                        });
            });
}

function wrapMethodToHandleInvalidOAuthTokenOrUndefinedGapi(fn, accessToken, client) {
  return Curry._2(fn, accessToken, client).then(function (res) {
                return Promise.resolve({
                            TAG: /* Ok */0,
                            _0: {
                              TAG: /* MethodDidReturnUsingOriginalToken */0,
                              _0: res
                            }
                          });
              }).catch(function (jsPromiseError) {
              var errorType = Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.getErrorType, jsPromiseError);
              if (typeof errorType === "number") {
                return Promise.resolve({
                            TAG: /* Error */1,
                            _0: {
                              TAG: /* MethodDidThrowPromiseError */0,
                              errorType: errorType,
                              maybeNewToken: undefined,
                              originalToken: accessToken
                            }
                          });
              }
              switch (errorType.TAG | 0) {
                case /* GapiIsUndefined */2 :
                    Util$SmartcutsMacros.wait(250).then(function (_timeoutId) {
                          return browser.runtime.reload();
                        });
                    return Promise.resolve({
                                TAG: /* Error */1,
                                _0: {
                                  TAG: /* MethodDidThrowPromiseError */0,
                                  errorType: errorType,
                                  maybeNewToken: undefined,
                                  originalToken: accessToken
                                }
                              });
                case /* UnauthorizedApiResponse */10 :
                    return removeCachedAuthTokenAndGetNewAuthTokenAndRetryApiCall(accessToken, client, fn);
                case /* HttpResponse */12 :
                    var httpResponse = errorType._0;
                    console.warn("Google api call failed:", httpResponse);
                    var _non401HttpStatusCode = httpResponse.result.error.code;
                    if (_non401HttpStatusCode !== 401) {
                      return Promise.resolve({
                                  TAG: /* Error */1,
                                  _0: {
                                    TAG: /* MethodDidThrowPromiseError */0,
                                    errorType: errorType,
                                    maybeNewToken: undefined,
                                    originalToken: accessToken
                                  }
                                });
                    } else {
                      return removeCachedAuthTokenAndGetNewAuthTokenAndRetryApiCall(accessToken, client, fn);
                    }
                default:
                  return Promise.resolve({
                              TAG: /* Error */1,
                              _0: {
                                TAG: /* MethodDidThrowPromiseError */0,
                                errorType: errorType,
                                maybeNewToken: undefined,
                                originalToken: accessToken
                              }
                            });
              }
            });
}

exports.removeCachedAuthTokenAndGetNewAuthTokenAndRetryApiCall = removeCachedAuthTokenAndGetNewAuthTokenAndRetryApiCall;
exports.wrapMethodToHandleInvalidOAuthTokenOrUndefinedGapi = wrapMethodToHandleInvalidOAuthTokenOrUndefinedGapi;
/* Util-SmartcutsMacros Not a pure module */
